<template>
    <transition name="fade">
        <div class="exchange-goods">
            <div class="exchange-body">
                <div class="title">选择新商品规格</div>
                <div class="body-content">
                    <div class="product-box">
                        <img :src="goods.product_image|default_img" alt="" class="product-img" />
                        <div class="product-info">
                            <div class="product-name">{{goods.product_name}}</div>
                            <div class="product-spec">原商品: {{goods.spec_info}}</div>
                            <div class="product-spec-new">新商品: {{curr_color_name && curr_size_name ? `${curr_color_name}${curr_size_name}` : '-'}}</div>
                        </div>
                    </div>
                    <div class="body-title">颜色分类</div>
                    <div class="product-color-list">
                        <div :class="['color-item',{active:item.uuid == curr_color}]" v-for="(item,index) in color_list" :key="index" @click="curr_color=item.uuid">
                            <img :src="''|default_img" alt="" class="color-img" />
                            <div class="color-name">黑色{{ item.name }}</div>
                        </div>
                    </div>
                    <div class="body-title">选择尺码</div>
                    <div class="product-size-list">
                        <div :class="['size-item',{active:item.uuid == curr_size}]" v-for="(item,index) in size_list" :key="index" @click="curr_size=item.uuid">
                            <div class="size-name">{{ item.name }}</div>
                        </div>
                    </div>
                    <div class="body-title">
                        换货数量<span>(最多可换1个)</span>
                    </div>
                    <div class="num-box">
                        <div class="btn" @click="onNumChange('minus')">-</div>
                        <div class="input">
                            <input type="text" v-model="num" class="num-input" />
                        </div>
                        <div class="btn" @click="onNumChange('plus')">+</div>
                    </div>
                </div>
                <div class="footer">
                    <div class="btn cancel" @click="close">取消</div>
                    <div class="btn confirm" @click="onConfirmExchange">确定</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script> 
import { productSpecList } from '@/api/index';
export default{
    name:"ExchangeGoods",
    props:{
        goods:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    data(){
        return{
            curr_color:'',
            curr_size:'',
            num:'1',
            spec_list:{},
        }
    },
    computed:{
        curr_color_name(){
            return this.color_list.find(item=>item.uuid === this.curr_color)?.name || '';
        },
        curr_size_name(){
            return this.size_list.find(item=>item.uuid === this.curr_size)?.name || '';
        },
        color_list(){
            const {color} = this.spec_list;
            if(!color) return [];
            return color || [];
        },
        size_list(){
            const {size} = this.spec_list;
            if(!size) return [];
            return size || [];
        },
    },
    mounted(){
        this.onGetSpecInfo();
        this.form.num = this.goods.quantity || 1;
    },
    methods:{
        onConfirmExchange(){
            if(!this.curr_color){
                this.$layer.msg('请选择颜色分类');
                return;
            }
            if(!this.curr_size){
                this.$layer.msg('请选择尺码');
                return;
            }
            this.$emit('confirm',{
                spec_color_uuid:this.curr_color,
                spec_size_uuid:this.curr_size,
                new_spec_quantity:this.num,
                color_name:this.curr_color_name,
                size_name:this.curr_size_name,
            })
        },
        onNumChange(type){
           switch(type){
            case 'minus':
                if(this.num <= 1){
                    this.num = 1;
                    return;
                }
                this.num--;
                break;
            case 'plus':
                if(this.num >= this.goods.quantity){
                    this.num = this.goods.quantity;
                    this.$layer.msg(`最多可换${this.num}个`);
                    return;
                }
                this.num++;
                break;
           } 
        },
        async onGetSpecInfo(){
            try{
                const {code,msg,data} = await productSpecList({product_id:this.goods.product_id});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-spec-list',data);
                this.spec_list = data;
            }catch(e){
                console.log('error',e);
                this.$layer.msg(e.msg);
            }
        },
        close(){
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
.exchange-goods{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    z-index:110;
    background:rgba(0,0,0,.5);
    display:flex;
    align-items:center;
    justify-content:center;
    .exchange-body{
        width:920px;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        .title{
            width:100%;
            text-align:center;
            border-bottom:1px solid #e0e0e0;
            padding:17px 0 13px 0;
            color:#0f1115;
            font-size:18px;
            font-weight:bold;
        }
        .body-content{
            padding:30px 50px 50px 50px;
            display:flex;
            flex-direction:column;
            .product-box{
                display:flex;
                column-gap:20px;
                margin-bottom:32px;
                .product-img{
                    width:96px;
                    height:96px;
                    border-radius:8px;
                    object-fit:cover;
                }
                .product-info{
                    display:flex;
                    flex-direction:column;
                    .product-name{
                        color:#333;
                        font-size:16px;
                        margin-bottom:13px;
                    }
                    .product-spec{
                        color:#666;
                        font-size:14px;
                        margin-bottom:8px;
                    }
                    .product-spec-new{
                        color:#ff5967;
                        font-size:14px;
                    }
                }
            }
            .body-title{
                display:flex;
                align-items: end;
                column-gap:10px;
                color:#333;
                font-size:18px;
                font-weight:bold;
                margin-bottom:20px;
                span{
                    font-weight:normal;
                    color:#666;
                    font-size:14px;
                }
            }
            .product-color-list{
                display:flex;
                align-items:center;
                column-gap:8px;
                margin-bottom:40px;
                .color-item{
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    border:1px solid #e3e3e3;
                    border-radius:3px;
                    padding:4px;
                    cursor:pointer;
                    &.active{
                        border:2px solid #ff5967;
                    }
                    .color-img{
                        width:30px;
                        height:30px;
                        border-radius:3px;
                        object-fit:cover;
                    }
                    .color-name{
                        color:#000;
                        font-size:14px;
                    }
                }
            }
            .product-size-list{
                display:flex;
                align-items:center;
                column-gap:8px;
                margin-bottom:40px;
                .size-item{
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    border:1px solid #e3e3e3;
                    border-radius:3px;
                    padding:9px 24px;
                    cursor:pointer;
                    &.active{
                        border:2px solid #ff5967;
                    }
                    .size-name{
                        color:#000;
                        font-size:14px;
                    }
                }
            }
            .num-box{
                width:165px;
                height:38px;
                border:1px solid #e3e3e3;
                border-radius:3px;
                display:flex;
                align-items:center;
                .btn{
                    width:38px;
                    height:100%;
                    line-height:38px;
                    text-align:center;
                    cursor:pointer;
                    color:#666;
                    font-size:16px;
                }
                .input{
                    flex:1;
                    max-width:88px;
                    border-left:1px solid #e3e3e3;
                    border-right:1px solid #e3e3e3;
                    height:100%;
                    input{
                        width:100%;
                        height:100%;
                        text-align:center;
                        border:none;
                        outline:none;
                    }
                }
            }
        }
        .footer{
            width:100%;
            border-top:1px solid #e0e0e0;
            padding:16px 0 24px 0;
            display:flex;
            justify-content:center;
            align-items:center;
            column-gap:16px;
            .btn{
                width:136px;
                height:40px;
                border-radius:4px;
                cursor: pointer;
                text-align:center;
                line-height:40px;
                &.cancel{
                    border:1px solid #e3e3e3;
                    color:#666;
                    font-size:14px;
                }
                &.confirm{
                    background:#ff5967;
                    color:#fff;
                    font-size:14px;
                }
            }
        }
    }
}
</style>